import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _f3382108 = () => interopDefault(import('../pages/ds/index.vue' /* webpackChunkName: "pages/ds/index" */))
const _b0b703aa = () => interopDefault(import('../pages/openurl.vue' /* webpackChunkName: "pages/openurl" */))
const _6fc857bd = () => interopDefault(import('../pages/ds/biz.vue' /* webpackChunkName: "pages/ds/biz" */))
const _2b105fd4 = () => interopDefault(import('../pages/ds/intro.vue' /* webpackChunkName: "pages/ds/intro" */))
const _677d9540 = () => interopDefault(import('../pages/ds/member.vue' /* webpackChunkName: "pages/ds/member" */))
const _0b01760c = () => interopDefault(import('../pages/or/guide.vue' /* webpackChunkName: "pages/or/guide" */))
const _5f47db66 = () => interopDefault(import('../pages/bp/bpa/SCR_BPA_0001.vue' /* webpackChunkName: "pages/bp/bpa/SCR_BPA_0001" */))
const _3c114144 = () => interopDefault(import('../pages/bp/bpa/SCR_BPA_0001A.vue' /* webpackChunkName: "pages/bp/bpa/SCR_BPA_0001A" */))
const _5e829258 = () => interopDefault(import('../pages/bp/bpa/SCR_BPA_0008.vue' /* webpackChunkName: "pages/bp/bpa/SCR_BPA_0008" */))
const _b8957316 = () => interopDefault(import('../pages/cm/cma/error.vue' /* webpackChunkName: "pages/cm/cma/error" */))
const _4ea2b9e9 = () => interopDefault(import('../pages/cm/cma/SCR_CMA_0001.vue' /* webpackChunkName: "pages/cm/cma/SCR_CMA_0001" */))
const _59de7840 = () => interopDefault(import('../pages/cs/csh/SCR_CSH_0000.vue' /* webpackChunkName: "pages/cs/csh/SCR_CSH_0000" */))
const _59c2493e = () => interopDefault(import('../pages/cs/csh/SCR_CSH_0001.vue' /* webpackChunkName: "pages/cs/csh/SCR_CSH_0001" */))
const _59a61a3c = () => interopDefault(import('../pages/cs/csh/SCR_CSH_0002.vue' /* webpackChunkName: "pages/cs/csh/SCR_CSH_0002" */))
const _5989eb3a = () => interopDefault(import('../pages/cs/csh/SCR_CSH_0003.vue' /* webpackChunkName: "pages/cs/csh/SCR_CSH_0003" */))
const _596dbc38 = () => interopDefault(import('../pages/cs/csh/SCR_CSH_0004.vue' /* webpackChunkName: "pages/cs/csh/SCR_CSH_0004" */))
const _e80ba2c2 = () => interopDefault(import('../pages/cs/csi/SCR_CSI_0001.vue' /* webpackChunkName: "pages/cs/csi/SCR_CSI_0001" */))
const _04ba84cc = () => interopDefault(import('../pages/cs/csk/SCR_CSK_0000.vue' /* webpackChunkName: "pages/cs/csk/SCR_CSK_0000" */))
const _049e55ca = () => interopDefault(import('../pages/cs/csk/SCR_CSK_0001.vue' /* webpackChunkName: "pages/cs/csk/SCR_CSK_0001" */))
const _048226c8 = () => interopDefault(import('../pages/cs/csk/SCR_CSK_0002.vue' /* webpackChunkName: "pages/cs/csk/SCR_CSK_0002" */))
const _92e7af4e = () => interopDefault(import('../pages/cs/csl/SCR_CSL_0001.vue' /* webpackChunkName: "pages/cs/csl/SCR_CSL_0001" */))
const _1baf07b7 = () => interopDefault(import('../pages/cs/csl/SCR_CSL_0001_P1.vue' /* webpackChunkName: "pages/cs/csl/SCR_CSL_0001_P1" */))
const _1bbd1f38 = () => interopDefault(import('../pages/cs/csl/SCR_CSL_0001_P2.vue' /* webpackChunkName: "pages/cs/csl/SCR_CSL_0001_P2" */))
const _1bcb36b9 = () => interopDefault(import('../pages/cs/csl/SCR_CSL_0001_P3.vue' /* webpackChunkName: "pages/cs/csl/SCR_CSL_0001_P3" */))
const _92932248 = () => interopDefault(import('../pages/cs/csl/SCR_CSL_0004.vue' /* webpackChunkName: "pages/cs/csl/SCR_CSL_0004" */))
const _33d984a6 = () => interopDefault(import('../pages/cs/csl/SCR_CSL_0004_I.vue' /* webpackChunkName: "pages/cs/csl/SCR_CSL_0004_I" */))
const _343c292d = () => interopDefault(import('../pages/cs/csl/SCR_CSL_0004_P.vue' /* webpackChunkName: "pages/cs/csl/SCR_CSL_0004_P" */))
const _6f596416 = () => interopDefault(import('../pages/cs/csm/SCR_CSM_0000.vue' /* webpackChunkName: "pages/cs/csm/SCR_CSM_0000" */))
const _6f677b97 = () => interopDefault(import('../pages/cs/csm/SCR_CSM_0001.vue' /* webpackChunkName: "pages/cs/csm/SCR_CSM_0001" */))
const _6f759318 = () => interopDefault(import('../pages/cs/csm/SCR_CSM_0002.vue' /* webpackChunkName: "pages/cs/csm/SCR_CSM_0002" */))
const _74306ee6 = () => interopDefault(import('../pages/cs/csn/SCR_CSN_0001_P.vue' /* webpackChunkName: "pages/cs/csn/SCR_CSN_0001_P" */))
const _9e708592 = () => interopDefault(import('../pages/ds/dsa/SCR_MBC_0050_02_1.vue' /* webpackChunkName: "pages/ds/dsa/SCR_MBC_0050_02_1" */))
const _7ffdc054 = () => interopDefault(import('../pages/ds/dsa/SCR_MBC_0113.vue' /* webpackChunkName: "pages/ds/dsa/SCR_MBC_0113" */))
const _1f1915fc = () => interopDefault(import('../pages/ds/dsa/SCR_MBC_0113_01.vue' /* webpackChunkName: "pages/ds/dsa/SCR_MBC_0113_01" */))
const _0cdcafae = () => interopDefault(import('../pages/ds/dsa/SCR_MBC_0113_01_1.vue' /* webpackChunkName: "pages/ds/dsa/SCR_MBC_0113_01_1" */))
const _1f272d7d = () => interopDefault(import('../pages/ds/dsa/SCR_MBC_0113_02.vue' /* webpackChunkName: "pages/ds/dsa/SCR_MBC_0113_02" */))
const _1f3544fe = () => interopDefault(import('../pages/ds/dsa/SCR_MBC_0113_03.vue' /* webpackChunkName: "pages/ds/dsa/SCR_MBC_0113_03" */))
const _1f435c7f = () => interopDefault(import('../pages/ds/dsa/SCR_MBC_0113_04.vue' /* webpackChunkName: "pages/ds/dsa/SCR_MBC_0113_04" */))
const _1f517400 = () => interopDefault(import('../pages/ds/dsa/SCR_MBC_0113_05.vue' /* webpackChunkName: "pages/ds/dsa/SCR_MBC_0113_05" */))
const _00b2713a = () => interopDefault(import('../pages/ds/dsa/videoTest.vue' /* webpackChunkName: "pages/ds/dsa/videoTest" */))
const _8e4de42a = () => interopDefault(import('../pages/ds/dst/SCR_DST_0015.vue' /* webpackChunkName: "pages/ds/dst/SCR_DST_0015" */))
const _27737988 = () => interopDefault(import('../pages/ds/keybiz/keyVisualList.vue' /* webpackChunkName: "pages/ds/keybiz/keyVisualList" */))
const _8a5b4678 = () => interopDefault(import('../pages/ds/keybiz/pdNotification.vue' /* webpackChunkName: "pages/ds/keybiz/pdNotification" */))
const _d1c0d7de = () => interopDefault(import('../pages/ds/rank/boxProduct.vue' /* webpackChunkName: "pages/ds/rank/boxProduct" */))
const _5f106b03 = () => interopDefault(import('../pages/ds/rank/new.vue' /* webpackChunkName: "pages/ds/rank/new" */))
const _6c6bc869 = () => interopDefault(import('../pages/ds/rank/pickup.vue' /* webpackChunkName: "pages/ds/rank/pickup" */))
const _7ef8123c = () => interopDefault(import('../pages/ds/rank/popular.vue' /* webpackChunkName: "pages/ds/rank/popular" */))
const _59f6f3c1 = () => interopDefault(import('../pages/ds/rank/rePurchase.vue' /* webpackChunkName: "pages/ds/rank/rePurchase" */))
const _34ebe745 = () => interopDefault(import('../pages/ds/rank/review.vue' /* webpackChunkName: "pages/ds/rank/review" */))
const _651ed28c = () => interopDefault(import('../pages/ev/evc/SCR_EVC_0001.vue' /* webpackChunkName: "pages/ev/evc/SCR_EVC_0001" */))
const _653b018e = () => interopDefault(import('../pages/ev/evc/SCR_EVC_0003.vue' /* webpackChunkName: "pages/ev/evc/SCR_EVC_0003" */))
const _658f8e94 = () => interopDefault(import('../pages/ev/evc/SCR_EVC_0009.vue' /* webpackChunkName: "pages/ev/evc/SCR_EVC_0009" */))
const _66d3ab2b = () => interopDefault(import('../pages/ev/evc/SCR_EVC_0011.vue' /* webpackChunkName: "pages/ev/evc/SCR_EVC_0011" */))
const _66efda2d = () => interopDefault(import('../pages/ev/evc/SCR_EVC_0013.vue' /* webpackChunkName: "pages/ev/evc/SCR_EVC_0013" */))
const _670c092f = () => interopDefault(import('../pages/ev/evc/SCR_EVC_0015.vue' /* webpackChunkName: "pages/ev/evc/SCR_EVC_0015" */))
const _67283831 = () => interopDefault(import('../pages/ev/evc/SCR_EVC_0017.vue' /* webpackChunkName: "pages/ev/evc/SCR_EVC_0017" */))
const _67446733 = () => interopDefault(import('../pages/ev/evc/SCR_EVC_0019.vue' /* webpackChunkName: "pages/ev/evc/SCR_EVC_0019" */))
const _1dfa25ca = () => interopDefault(import('../pages/ev/evd/SCR_EVD_0001.vue' /* webpackChunkName: "pages/ev/evd/SCR_EVD_0001" */))
const _1e1654cc = () => interopDefault(import('../pages/ev/evd/SCR_EVD_0003.vue' /* webpackChunkName: "pages/ev/evd/SCR_EVD_0003" */))
const _1e5cca51 = () => interopDefault(import('../pages/ev/evd/SCR_EVD_0008.vue' /* webpackChunkName: "pages/ev/evd/SCR_EVD_0008" */))
const _1e6ae1d2 = () => interopDefault(import('../pages/ev/evd/SCR_EVD_0009.vue' /* webpackChunkName: "pages/ev/evd/SCR_EVD_0009" */))
const _1faefe69 = () => interopDefault(import('../pages/ev/evd/SCR_EVD_0011.vue' /* webpackChunkName: "pages/ev/evd/SCR_EVD_0011" */))
const _1165db0a = () => interopDefault(import('../pages/fb/fba/SCR_FBA_0001.vue' /* webpackChunkName: "pages/fb/fba/SCR_FBA_0001" */))
const _112d7d06 = () => interopDefault(import('../pages/fb/fba/SCR_FBA_0003.vue' /* webpackChunkName: "pages/fb/fba/SCR_FBA_0003" */))
const _10f51f02 = () => interopDefault(import('../pages/fb/fba/SCR_FBA_0005.vue' /* webpackChunkName: "pages/fb/fba/SCR_FBA_0005" */))
const _32008fae = () => interopDefault(import('../pages/fb/fba/SCR_FBA_0005_S1.vue' /* webpackChunkName: "pages/fb/fba/SCR_FBA_0005_S1" */))
const _10d8f000 = () => interopDefault(import('../pages/fb/fba/SCR_FBA_0006.vue' /* webpackChunkName: "pages/fb/fba/SCR_FBA_0006" */))
const _9faf348e = () => interopDefault(import('../pages/fb/fbb/SCR_FBB_0001.vue' /* webpackChunkName: "pages/fb/fbb/SCR_FBB_0001" */))
const _f6dc9554 = () => interopDefault(import('../pages/fb/fbb/SCR_FBB_0001T1.vue' /* webpackChunkName: "pages/fb/fbb/SCR_FBB_0001T1" */))
const _0e9e16dc = () => interopDefault(import('../pages/fb/fbb/SCR_FBB_0001T1B.vue' /* webpackChunkName: "pages/fb/fbb/SCR_FBB_0001T1B" */))
const _f6c06652 = () => interopDefault(import('../pages/fb/fbb/SCR_FBB_0001T2.vue' /* webpackChunkName: "pages/fb/fbb/SCR_FBB_0001T2" */))
const _9f93058c = () => interopDefault(import('../pages/fb/fbb/SCR_FBB_0002.vue' /* webpackChunkName: "pages/fb/fbb/SCR_FBB_0002" */))
const _9f76d68a = () => interopDefault(import('../pages/fb/fbb/SCR_FBB_0003.vue' /* webpackChunkName: "pages/fb/fbb/SCR_FBB_0003" */))
const _9f3e7886 = () => interopDefault(import('../pages/fb/fbb/SCR_FBB_0005.vue' /* webpackChunkName: "pages/fb/fbb/SCR_FBB_0005" */))
const _9ee9eb80 = () => interopDefault(import('../pages/fb/fbb/SCR_FBB_0008.vue' /* webpackChunkName: "pages/fb/fbb/SCR_FBB_0008" */))
const _9c61b252 = () => interopDefault(import('../pages/fb/fbb/SCR_FBB_0010.vue' /* webpackChunkName: "pages/fb/fbb/SCR_FBB_0010" */))
const _9bf0f64a = () => interopDefault(import('../pages/fb/fbb/SCR_FBB_0014.vue' /* webpackChunkName: "pages/fb/fbb/SCR_FBB_0014" */))
const _9bd4c748 = () => interopDefault(import('../pages/fb/fbb/SCR_FBB_0015.vue' /* webpackChunkName: "pages/fb/fbb/SCR_FBB_0015" */))
const _d0ed5a2a = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0080.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0080" */))
const _2bd97c7a = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0082_01.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0082_01" */))
const _2bbd4d78 = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0082_02.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0082_02" */))
const _2ba11e76 = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0082_03.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0082_03" */))
const _2b84ef74 = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0082_04.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0082_04" */))
const _2b68c072 = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0082_05.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0082_05" */))
const _2b4c9170 = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0082_06.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0082_06" */))
const _2b30626e = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0082_07.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0082_07" */))
const _2af8046a = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0082_09.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0082_09" */))
const _288bfa3e = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0082_10.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0082_10" */))
const _d07c9e22 = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0084.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0084" */))
const _ecd01582 = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0086_01.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0086_01" */))
const _64c92820 = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0086A.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0086A" */))
const _cd0390e2 = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0086B_01.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0086B_01" */))
const _cce761e0 = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0086B_02.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0086B_02" */))
const _64e55722 = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0086C.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0086C" */))
const _cd6779ea = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0091.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0091" */))
const _338e44ba = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0093_01.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0093_01" */))
const _69192ecc = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0093A_01.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0093A_01" */))
const _6927464d = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0093A_02.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0093A_02" */))
const _d6c21df6 = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0093B.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0093B" */))
const _38db888a = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0093C_01.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0093C_01" */))
const _38e9a00b = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0093C_02.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0093C_02" */))
const _d3749bba = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0094A.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0094A" */))
const _1ddc6440 = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0096_01.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0096_01" */))
const _1dea7bc1 = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0096_02.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0096_02" */))
const _557feadd = () => interopDefault(import('../pages/mb/mba/SCR_MBA_0099_01.vue' /* webpackChunkName: "pages/mb/mba/SCR_MBA_0099_01" */))
const _fe4ce5be = () => interopDefault(import('../pages/mb/mbb/SCR_MBB_0097_01.vue' /* webpackChunkName: "pages/mb/mbb/SCR_MBB_0097_01" */))
const _04195efc = () => interopDefault(import('../pages/mb/mbb/SCR_MBB_0097A.vue' /* webpackChunkName: "pages/mb/mbb/SCR_MBB_0097A" */))
const _03fd2ffa = () => interopDefault(import('../pages/mb/mbb/SCR_MBB_0097B.vue' /* webpackChunkName: "pages/mb/mbb/SCR_MBB_0097B" */))
const _528a3ad0 = () => interopDefault(import('../pages/mb/mbb/SCR_MBB_0098.vue' /* webpackChunkName: "pages/mb/mbb/SCR_MBB_0098" */))
const _52985251 = () => interopDefault(import('../pages/mb/mbb/SCR_MBB_0099.vue' /* webpackChunkName: "pages/mb/mbb/SCR_MBB_0099" */))
const _3ec92eb8 = () => interopDefault(import('../pages/mb/mbb/SCR_MBB_0107_02.vue' /* webpackChunkName: "pages/mb/mbb/SCR_MBB_0107_02" */))
const _20de27b8 = () => interopDefault(import('../pages/mb/mbb/SCR_MBB_0107A_01.vue' /* webpackChunkName: "pages/mb/mbb/SCR_MBB_0107A_01" */))
const _ee8156d2 = () => interopDefault(import('../pages/mb/mbb/SCR_MBB_0107B_01.vue' /* webpackChunkName: "pages/mb/mbb/SCR_MBB_0107B_01" */))
const _496705ba = () => interopDefault(import('../pages/mb/mbb/SCR_MBB_0109A_01.vue' /* webpackChunkName: "pages/mb/mbb/SCR_MBB_0109A_01" */))
const _49751d3b = () => interopDefault(import('../pages/mb/mbb/SCR_MBB_0109A_02.vue' /* webpackChunkName: "pages/mb/mbb/SCR_MBB_0109A_02" */))
const _498334bc = () => interopDefault(import('../pages/mb/mbb/SCR_MBB_0109A_03.vue' /* webpackChunkName: "pages/mb/mbb/SCR_MBB_0109A_03" */))
const _9d6f9ace = () => interopDefault(import('../pages/mb/mbb/SCR_MBB_0109B_01.vue' /* webpackChunkName: "pages/mb/mbb/SCR_MBB_0109B_01" */))
const _9d536bcc = () => interopDefault(import('../pages/mb/mbb/SCR_MBB_0109B_02.vue' /* webpackChunkName: "pages/mb/mbb/SCR_MBB_0109B_02" */))
const _9d373cca = () => interopDefault(import('../pages/mb/mbb/SCR_MBB_0109B_03.vue' /* webpackChunkName: "pages/mb/mbb/SCR_MBB_0109B_03" */))
const _3234484f = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0110.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0110" */))
const _153fcb82 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0110A.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0110A" */))
const _6fac140e = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0110A_01.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0110A_01" */))
const _6fba2b8f = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0110A_02.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0110A_02" */))
const _50e57e26 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0110B_01.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0110B_01" */))
const _50c94f24 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0110B_02.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0110B_02" */))
const _5ed47500 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0111_01.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0111_01" */))
const _16f4a421 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0111A.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0111A" */))
const _1702bba2 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0111B.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0111B" */))
const _3b9409ac = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0111D_01.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0111D_01" */))
const _3ba2212d = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0111D_02.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0111D_02" */))
const _3bb038ae = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0111D_03.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0111D_03" */))
const _32507751 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0112.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0112" */))
const _2fcf2744 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0112_2.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0112_2" */))
const _325e8ed2 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0113.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0113" */))
const _d31008c6 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0114_01.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0114_01" */))
const _d2f3d9c4 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0114_02.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0114_02" */))
const _327abdd4 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0115.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0115" */))
const _034daf08 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0115_01.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0115_01" */))
const _03318006 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0115_02.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0115_02" */))
const _03155104 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0115_03.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0115_03" */))
const _3288d555 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0116.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0116" */))
const _63c8fb8c = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0117_01.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0117_01" */))
const _63accc8a = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0117_02.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0117_02" */))
const _33e920ee = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0120.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0120" */))
const _2abc6a9e = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0124_01.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0124_01" */))
const _2aca821f = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0124_02.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0124_02" */))
const _2ad899a0 = () => interopDefault(import('../pages/mb/mbc/SCR_MBC_0124_03.vue' /* webpackChunkName: "pages/mb/mbc/SCR_MBC_0124_03" */))
const _85a48c3a = () => interopDefault(import('../pages/ms/msb/SCR_MSB_0001.vue' /* webpackChunkName: "pages/ms/msb/SCR_MSB_0001" */))
const _85885d38 = () => interopDefault(import('../pages/ms/msb/SCR_MSB_0002.vue' /* webpackChunkName: "pages/ms/msb/SCR_MSB_0002" */))
const _856c2e36 = () => interopDefault(import('../pages/ms/msb/SCR_MSB_0003.vue' /* webpackChunkName: "pages/ms/msb/SCR_MSB_0003" */))
const _854fff34 = () => interopDefault(import('../pages/ms/msb/SCR_MSB_0004.vue' /* webpackChunkName: "pages/ms/msb/SCR_MSB_0004" */))
const _84c3142a = () => interopDefault(import('../pages/ms/msb/SCR_MSB_0009.vue' /* webpackChunkName: "pages/ms/msb/SCR_MSB_0009" */))
const _3a276f94 = () => interopDefault(import('../pages/ms/msb/SCR_MSB_TEMP.vue' /* webpackChunkName: "pages/ms/msb/SCR_MSB_TEMP" */))
const _76090d21 = () => interopDefault(import('../pages/ms/msc/SCR_MSC_0001.vue' /* webpackChunkName: "pages/ms/msc/SCR_MSC_0001" */))
const _761724a2 = () => interopDefault(import('../pages/ms/msc/SCR_MSC_0002.vue' /* webpackChunkName: "pages/ms/msc/SCR_MSC_0002" */))
const _76253c23 = () => interopDefault(import('../pages/ms/msc/SCR_MSC_0003.vue' /* webpackChunkName: "pages/ms/msc/SCR_MSC_0003" */))
const _308098c6 = () => interopDefault(import('../pages/ms/mse/SCR_MSE_0001.vue' /* webpackChunkName: "pages/ms/mse/SCR_MSE_0001" */))
const _306469c4 = () => interopDefault(import('../pages/ms/mse/SCR_MSE_0002.vue' /* webpackChunkName: "pages/ms/mse/SCR_MSE_0002" */))
const _5b6390bc = () => interopDefault(import('../pages/ms/msg/SCR_MSG_0015.vue' /* webpackChunkName: "pages/ms/msg/SCR_MSG_0015" */))
const _5b71a83d = () => interopDefault(import('../pages/ms/msg/SCR_MSG_0016.vue' /* webpackChunkName: "pages/ms/msg/SCR_MSG_0016" */))
const _5b7fbfbe = () => interopDefault(import('../pages/ms/msg/SCR_MSG_0017.vue' /* webpackChunkName: "pages/ms/msg/SCR_MSG_0017" */))
const _5b9beec0 = () => interopDefault(import('../pages/ms/msg/SCR_MSG_0019.vue' /* webpackChunkName: "pages/ms/msg/SCR_MSG_0019" */))
const _5ce00b57 = () => interopDefault(import('../pages/ms/msg/SCR_MSG_0021.vue' /* webpackChunkName: "pages/ms/msg/SCR_MSG_0021" */))
const _e3707cfc = () => interopDefault(import('../pages/or/ora/SCR_ORA_0001.vue' /* webpackChunkName: "pages/or/ora/SCR_ORA_0001" */))
const _e2ffc0f4 = () => interopDefault(import('../pages/or/ora/SCR_ORA_0005.vue' /* webpackChunkName: "pages/or/ora/SCR_ORA_0005" */))
const _5f52a172 = () => interopDefault(import('../pages/or/ora/SCR_ORA_0005_S1.vue' /* webpackChunkName: "pages/or/ora/SCR_ORA_0005_S1" */))
const _e2e391f2 = () => interopDefault(import('../pages/or/ora/SCR_ORA_0006.vue' /* webpackChunkName: "pages/or/ora/SCR_ORA_0006" */))
const _e2c762f0 = () => interopDefault(import('../pages/or/ora/SCR_ORA_0007.vue' /* webpackChunkName: "pages/or/ora/SCR_ORA_0007" */))
const _e28f04ec = () => interopDefault(import('../pages/or/ora/SCR_ORA_0009.vue' /* webpackChunkName: "pages/or/ora/SCR_ORA_0009" */))
const _49b2f9af = () => interopDefault(import('../pages/or/ora/SCR_ORA_0009I.vue' /* webpackChunkName: "pages/or/ora/SCR_ORA_0009I" */))
const _4a159e36 = () => interopDefault(import('../pages/or/ora/SCR_ORA_0009P.vue' /* webpackChunkName: "pages/or/ora/SCR_ORA_0009P" */))
const _e022fac0 = () => interopDefault(import('../pages/or/ora/SCR_ORA_0010.vue' /* webpackChunkName: "pages/or/ora/SCR_ORA_0010" */))
const _e006cbbe = () => interopDefault(import('../pages/or/ora/SCR_ORA_0011.vue' /* webpackChunkName: "pages/or/ora/SCR_ORA_0011" */))
const _dfce6dba = () => interopDefault(import('../pages/or/ora/SCR_ORA_0013.vue' /* webpackChunkName: "pages/or/ora/SCR_ORA_0013" */))
const _dfb23eb8 = () => interopDefault(import('../pages/or/ora/SCR_ORA_0014.vue' /* webpackChunkName: "pages/or/ora/SCR_ORA_0014" */))
const _df960fb6 = () => interopDefault(import('../pages/or/ora/SCR_ORA_0015.vue' /* webpackChunkName: "pages/or/ora/SCR_ORA_0015" */))
const _21419187 = () => interopDefault(import('../pages/or/orb/cancelCompletePopUp.vue' /* webpackChunkName: "pages/or/orb/cancelCompletePopUp" */))
const _238da3a3 = () => interopDefault(import('../pages/or/orb/ExchangeList.vue' /* webpackChunkName: "pages/or/orb/ExchangeList" */))
const _4b27311b = () => interopDefault(import('../pages/or/orb/NoCancelList.vue' /* webpackChunkName: "pages/or/orb/NoCancelList" */))
const _7bfe1df8 = () => interopDefault(import('../pages/or/orb/NoExchangeList.vue' /* webpackChunkName: "pages/or/orb/NoExchangeList" */))
const _aa11eb62 = () => interopDefault(import('../pages/or/orb/OrBtnCmp.vue' /* webpackChunkName: "pages/or/orb/OrBtnCmp" */))
const _17768b8a = () => interopDefault(import('../pages/or/orb/OrClAdditPyUnit.vue' /* webpackChunkName: "pages/or/orb/OrClAdditPyUnit" */))
const _d3e37d7c = () => interopDefault(import('../pages/or/orb/OrClDlvInfoUnit.vue' /* webpackChunkName: "pages/or/orb/OrClDlvInfoUnit" */))
const _3964ab64 = () => interopDefault(import('../pages/or/orb/OrClPdListUnit.vue' /* webpackChunkName: "pages/or/orb/OrClPdListUnit" */))
const _cd94ab26 = () => interopDefault(import('../pages/or/orb/OrClRetnInfoUnit.vue' /* webpackChunkName: "pages/or/orb/OrClRetnInfoUnit" */))
const _1c881b54 = () => interopDefault(import('../pages/or/orb/OrClRetnPyInfoUnit.vue' /* webpackChunkName: "pages/or/orb/OrClRetnPyInfoUnit" */))
const _472314c0 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0001.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0001" */))
const _47312c41 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0002.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0002" */))
const _473f43c2 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0003.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0003" */))
const _474d5b43 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0004.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0004" */))
const _475b72c4 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0005.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0005" */))
const _691aa96e = () => interopDefault(import('../pages/or/orb/SCR_ORB_0005_S1.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0005_S1" */))
const _47698a45 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0006.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0006" */))
const _4777a1c6 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0007.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0007" */))
const _48c9d5de = () => interopDefault(import('../pages/or/orb/SCR_ORB_0010.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0010" */))
const _48f41c61 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0013.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0013" */))
const _490233e2 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0014.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0014" */))
const _49104b63 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0015.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0015" */))
const _491e62e4 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0016.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0016" */))
const _492c7a65 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0017.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0017" */))
const _493a91e6 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0018.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0018" */))
const _4948a967 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0019.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0019" */))
const _4a8cc5fe = () => interopDefault(import('../pages/or/orb/SCR_ORB_0021.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0021" */))
const _4aa8f500 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0023.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0023" */))
const _4ab70c81 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0024.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0024" */))
const _4ac52402 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0025.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0025" */))
const _4ad33b83 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0026.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0026" */))
const _4c5dcd9f = () => interopDefault(import('../pages/or/orb/SCR_ORB_0033.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0033" */))
const _4c881422 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0036.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0036" */))
const _4c962ba3 = () => interopDefault(import('../pages/or/orb/SCR_ORB_0037.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0037" */))
const _4f9d385a = () => interopDefault(import('../pages/or/orb/SCR_ORB_0050.vue' /* webpackChunkName: "pages/or/orb/SCR_ORB_0050" */))
const _00067afc = () => interopDefault(import('../pages/or/orb/UX_07_055.vue' /* webpackChunkName: "pages/or/orb/UX_07_055" */))
const _2fc473e6 = () => interopDefault(import('../pages/or/orb/UX_07_125.vue' /* webpackChunkName: "pages/or/orb/UX_07_125" */))
const _00033004 = () => interopDefault(import('../pages/or/orc/SCR_ORC_0001.vue' /* webpackChunkName: "pages/or/orc/SCR_ORC_0001" */))
const _28becc6e = () => interopDefault(import('../pages/or/orc/SCR_ORC_0001_T1.vue' /* webpackChunkName: "pages/or/orc/SCR_ORC_0001_T1" */))
const _28cce3ef = () => interopDefault(import('../pages/or/orc/SCR_ORC_0001_T2.vue' /* webpackChunkName: "pages/or/orc/SCR_ORC_0001_T2" */))
const _28dafb70 = () => interopDefault(import('../pages/or/orc/SCR_ORC_0001_T3.vue' /* webpackChunkName: "pages/or/orc/SCR_ORC_0001_T3" */))
const _28e912f1 = () => interopDefault(import('../pages/or/orc/SCR_ORC_0001_T4.vue' /* webpackChunkName: "pages/or/orc/SCR_ORC_0001_T4" */))
const _b31213c2 = () => interopDefault(import('../pages/or/orc/SCR_ORC_0001_T4_P1.vue' /* webpackChunkName: "pages/or/orc/SCR_ORC_0001_T4_P1" */))
const _b2f5e4c0 = () => interopDefault(import('../pages/or/orc/SCR_ORC_0001_T4_P2.vue' /* webpackChunkName: "pages/or/orc/SCR_ORC_0001_T4_P2" */))
const _28f72a72 = () => interopDefault(import('../pages/or/orc/SCR_ORC_0001_T5.vue' /* webpackChunkName: "pages/or/orc/SCR_ORC_0001_T5" */))
const _001a9700 = () => interopDefault(import('../pages/or/orc/SCR_ORC_0003.vue' /* webpackChunkName: "pages/or/orc/SCR_ORC_0003" */))
const _0052f504 = () => interopDefault(import('../pages/or/orc/SCR_ORC_0007.vue' /* webpackChunkName: "pages/or/orc/SCR_ORC_0007" */))
const _9a00fdc8 = () => interopDefault(import('../pages/pd/pdm/SCR_PDM_0002.vue' /* webpackChunkName: "pages/pd/pdm/SCR_PDM_0002" */))
const _4f3a09d1 = () => interopDefault(import('../pages/pd/pdr/SCR_PDR_0001.vue' /* webpackChunkName: "pages/pd/pdr/SCR_PDR_0001" */))
const _0807458e = () => interopDefault(import('../pages/pd/pds/SCR_PDS_0000.vue' /* webpackChunkName: "pages/pd/pds/SCR_PDS_0000" */))
const _084dbb13 = () => interopDefault(import('../pages/pd/pds/SCR_PDS_0005.vue' /* webpackChunkName: "pages/pd/pds/SCR_PDS_0005" */))
const _085bd294 = () => interopDefault(import('../pages/pd/pds/SCR_PDS_0006.vue' /* webpackChunkName: "pages/pd/pds/SCR_PDS_0006" */))
const _7e1e9f66 = () => interopDefault(import('../pages/pd/pdt/SCR_PDT_0001.vue' /* webpackChunkName: "pages/pd/pdt/SCR_PDT_0001" */))
const _7e027064 = () => interopDefault(import('../pages/pd/pdt/SCR_PDT_0002.vue' /* webpackChunkName: "pages/pd/pdt/SCR_PDT_0002" */))
const _7de64162 = () => interopDefault(import('../pages/pd/pdt/SCR_PDT_0003.vue' /* webpackChunkName: "pages/pd/pdt/SCR_PDT_0003" */))
const _7dca1260 = () => interopDefault(import('../pages/pd/pdt/SCR_PDT_0004.vue' /* webpackChunkName: "pages/pd/pdt/SCR_PDT_0004" */))
const _276c97e9 = () => interopDefault(import('../pages/py/pya/SCR_PYA_0002.vue' /* webpackChunkName: "pages/py/pya/SCR_PYA_0002" */))
const _277aaf6a = () => interopDefault(import('../pages/py/pya/SCR_PYA_0003.vue' /* webpackChunkName: "pages/py/pya/SCR_PYA_0003" */))
const _2788c6eb = () => interopDefault(import('../pages/py/pya/SCR_PYA_0004.vue' /* webpackChunkName: "pages/py/pya/SCR_PYA_0004" */))
const _2796de6c = () => interopDefault(import('../pages/py/pya/SCR_PYA_0005.vue' /* webpackChunkName: "pages/py/pya/SCR_PYA_0005" */))
const _27b30d6e = () => interopDefault(import('../pages/py/pya/SCR_PYA_0007.vue' /* webpackChunkName: "pages/py/pya/SCR_PYA_0007" */))
const _3254929e = () => interopDefault(import('../pages/ug/ugc/SCR_UGC_030.vue' /* webpackChunkName: "pages/ug/ugc/SCR_UGC_030" */))
const _0e3d994e = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_0004.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_0004" */))
const _0e67dfd1 = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_0007.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_0007" */))
const _0e75f752 = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_0008.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_0008" */))
const _0ff271ed = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_0014.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_0014" */))
const _1038e772 = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_0019.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_0019" */))
const _118b1b8a = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_0022.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_0022" */))
const _1199330b = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_0023.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_0023" */))
const _11dfa890 = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_0028.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_0028" */))
const _2a2d12d2 = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_00282.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_00282" */))
const _11edc011 = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_0029.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_0029" */))
const _1323c527 = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_0030.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_0030" */))
const _1331dca8 = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_0031.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_0031" */))
const _133ff429 = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_0032.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_0032" */))
const _134e0baa = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_0033.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_0033" */))
const _62a316c6 = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_0033_P1.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_0033_P1" */))
const _f16d0336 = () => interopDefault(import('../pages/ug/ugd/SCR_UGD_00up.vue' /* webpackChunkName: "pages/ug/ugd/SCR_UGD_00up" */))
const _5624268a = () => interopDefault(import('../pages/ug/ugl/SCR_UGL_0001.vue' /* webpackChunkName: "pages/ug/ugl/SCR_UGL_0001" */))
const _e46d800e = () => interopDefault(import('../pages/ug/ugm/SCR_UGM_0001.vue' /* webpackChunkName: "pages/ug/ugm/SCR_UGM_0001" */))
const _e451510c = () => interopDefault(import('../pages/ug/ugm/SCR_UGM_0002.vue' /* webpackChunkName: "pages/ug/ugm/SCR_UGM_0002" */))
const _8f498c9a = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0001.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0001" */))
const _8f2d5d98 = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0002.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0002" */))
const _8f112e96 = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0003.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0003" */))
const _6b2599db = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0003_P1.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0003_P1" */))
const _5671284b = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_00030.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_00030" */))
const _8ef4ff94 = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0004.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0004" */))
const _8ed8d092 = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0005.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0005" */))
const _8ea0728e = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0007.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0007" */))
const _0aaa4d57 = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0007_P1.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0007_P1" */))
const _8e68148a = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0009.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0009" */))
const _8bfc0a5e = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0010.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0010" */))
const _7072fb82 = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0010_P1.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0010_P1" */))
const _8bc3ac5a = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0012.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0012" */))
const _8ba77d58 = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0013.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0013" */))
const _8b8b4e56 = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0014.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0014" */))
const _8b36c150 = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0017.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0017" */))
const _8b1a924e = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0018.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0018" */))
const _8afe634c = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0019.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0019" */))
const _6eb11616 = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0019_P1.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0019_P1" */))
const _88925920 = () => interopDefault(import('../pages/ug/ugp/SCR_UGP_0020.vue' /* webpackChunkName: "pages/ug/ugp/SCR_UGP_0020" */))
const _4cd852d1 = () => interopDefault(import('../pages/ds/bulkOrder/dsList/_id.vue' /* webpackChunkName: "pages/ds/bulkOrder/dsList/_id" */))
const _5a65bfbb = () => interopDefault(import('../pages/ds/pickupOrder/dsList/_id.vue' /* webpackChunkName: "pages/ds/pickupOrder/dsList/_id" */))
const _6cf86890 = () => interopDefault(import('../pages/ds/quickOrder/dsList/_id.vue' /* webpackChunkName: "pages/ds/quickOrder/dsList/_id" */))
const _481e94b1 = () => interopDefault(import('../pages/ds/bulkOrder/_id.vue' /* webpackChunkName: "pages/ds/bulkOrder/_id" */))
const _48717569 = () => interopDefault(import('../pages/ds/diy/_id.vue' /* webpackChunkName: "pages/ds/diy/_id" */))
const _02b4460f = () => interopDefault(import('../pages/ds/diy2/_id.vue' /* webpackChunkName: "pages/ds/diy2/_id" */))
const _240c94cc = () => interopDefault(import('../pages/ds/dst/_id.vue' /* webpackChunkName: "pages/ds/dst/_id" */))
const _382fd19c = () => interopDefault(import('../pages/ds/dsTest/_id.vue' /* webpackChunkName: "pages/ds/dsTest/_id" */))
const _0ad7d936 = () => interopDefault(import('../pages/ds/exbt/_id.vue' /* webpackChunkName: "pages/ds/exbt/_id" */))
const _bf774ba6 = () => interopDefault(import('../pages/ds/fb/_id.vue' /* webpackChunkName: "pages/ds/fb/_id" */))
const _f12edb08 = () => interopDefault(import('../pages/ds/godbin/_id.vue' /* webpackChunkName: "pages/ds/godbin/_id" */))
const _1547c9ab = () => interopDefault(import('../pages/ds/goods/_id.vue' /* webpackChunkName: "pages/ds/goods/_id" */))
const _7172c41b = () => interopDefault(import('../pages/ds/goodssub/_id.vue' /* webpackChunkName: "pages/ds/goodssub/_id" */))
const _1fb1ce75 = () => interopDefault(import('../pages/ds/new/_id.vue' /* webpackChunkName: "pages/ds/new/_id" */))
const _ecf109f2 = () => interopDefault(import('../pages/ds/pickupOrder/_id.vue' /* webpackChunkName: "pages/ds/pickupOrder/_id" */))
const _66309518 = () => interopDefault(import('../pages/ds/prodGift/_id.vue' /* webpackChunkName: "pages/ds/prodGift/_id" */))
const _bb9c305c = () => interopDefault(import('../pages/ds/quickOrder/_id.vue' /* webpackChunkName: "pages/ds/quickOrder/_id" */))
const _4b5a961d = () => interopDefault(import('../pages/ds/rank/_id.vue' /* webpackChunkName: "pages/ds/rank/_id" */))
const _185a9908 = () => interopDefault(import('../pages/ds/recmd/_id.vue' /* webpackChunkName: "pages/ds/recmd/_id" */))
const _790a6b48 = () => interopDefault(import('../pages/ds/recmd2/_id.vue' /* webpackChunkName: "pages/ds/recmd2/_id" */))
const _52126ba2 = () => interopDefault(import('../pages/ds/specialist/_id.vue' /* webpackChunkName: "pages/ds/specialist/_id" */))
const _52695098 = () => interopDefault(import('../pages/ds/specialProds/_id.vue' /* webpackChunkName: "pages/ds/specialProds/_id" */))
const _358cc2b5 = () => interopDefault(import('../pages/ds/dsBrand/_id/_brandId.vue' /* webpackChunkName: "pages/ds/dsBrand/_id/_brandId" */))
const _2396abe2 = () => interopDefault(import('../pages/ds/spexhbt/_id/_exbtId.vue' /* webpackChunkName: "pages/ds/spexhbt/_id/_exbtId" */))
const _6c86645a = () => interopDefault(import('../pages/ds/exhCtgr/_cnrId/_lgCtgrNo/_mdCtgrNo/_smCtgrNo.vue' /* webpackChunkName: "pages/ds/exhCtgr/_cnrId/_lgCtgrNo/_mdCtgrNo/_smCtgrNo" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/ds",
    component: _f3382108,
    name: "ds"
  }, {
    path: "/openurl",
    component: _b0b703aa,
    name: "openurl"
  }, {
    path: "/ds/biz",
    component: _6fc857bd,
    name: "ds-biz"
  }, {
    path: "/ds/intro",
    component: _2b105fd4,
    name: "ds-intro"
  }, {
    path: "/ds/member",
    component: _677d9540,
    name: "ds-member"
  }, {
    path: "/or/guide",
    component: _0b01760c,
    name: "or-guide"
  }, {
    path: "/bp/bpa/SCR_BPA_0001",
    component: _5f47db66,
    name: "bp-bpa-SCR_BPA_0001"
  }, {
    path: "/bp/bpa/SCR_BPA_0001A",
    component: _3c114144,
    name: "bp-bpa-SCR_BPA_0001A"
  }, {
    path: "/bp/bpa/SCR_BPA_0008",
    component: _5e829258,
    name: "bp-bpa-SCR_BPA_0008"
  }, {
    path: "/cm/cma/error",
    component: _b8957316,
    name: "cm-cma-error"
  }, {
    path: "/cm/cma/SCR_CMA_0001",
    component: _4ea2b9e9,
    name: "cm-cma-SCR_CMA_0001"
  }, {
    path: "/cs/csh/SCR_CSH_0000",
    component: _59de7840,
    name: "cs-csh-SCR_CSH_0000"
  }, {
    path: "/cs/csh/SCR_CSH_0001",
    component: _59c2493e,
    name: "cs-csh-SCR_CSH_0001"
  }, {
    path: "/cs/csh/SCR_CSH_0002",
    component: _59a61a3c,
    name: "cs-csh-SCR_CSH_0002"
  }, {
    path: "/cs/csh/SCR_CSH_0003",
    component: _5989eb3a,
    name: "cs-csh-SCR_CSH_0003"
  }, {
    path: "/cs/csh/SCR_CSH_0004",
    component: _596dbc38,
    name: "cs-csh-SCR_CSH_0004"
  }, {
    path: "/cs/csi/SCR_CSI_0001",
    component: _e80ba2c2,
    name: "cs-csi-SCR_CSI_0001"
  }, {
    path: "/cs/csk/SCR_CSK_0000",
    component: _04ba84cc,
    name: "cs-csk-SCR_CSK_0000"
  }, {
    path: "/cs/csk/SCR_CSK_0001",
    component: _049e55ca,
    name: "cs-csk-SCR_CSK_0001"
  }, {
    path: "/cs/csk/SCR_CSK_0002",
    component: _048226c8,
    name: "cs-csk-SCR_CSK_0002"
  }, {
    path: "/cs/csl/SCR_CSL_0001",
    component: _92e7af4e,
    name: "cs-csl-SCR_CSL_0001"
  }, {
    path: "/cs/csl/SCR_CSL_0001_P1",
    component: _1baf07b7,
    name: "cs-csl-SCR_CSL_0001_P1"
  }, {
    path: "/cs/csl/SCR_CSL_0001_P2",
    component: _1bbd1f38,
    name: "cs-csl-SCR_CSL_0001_P2"
  }, {
    path: "/cs/csl/SCR_CSL_0001_P3",
    component: _1bcb36b9,
    name: "cs-csl-SCR_CSL_0001_P3"
  }, {
    path: "/cs/csl/SCR_CSL_0004",
    component: _92932248,
    name: "cs-csl-SCR_CSL_0004"
  }, {
    path: "/cs/csl/SCR_CSL_0004_I",
    component: _33d984a6,
    name: "cs-csl-SCR_CSL_0004_I"
  }, {
    path: "/cs/csl/SCR_CSL_0004_P",
    component: _343c292d,
    name: "cs-csl-SCR_CSL_0004_P"
  }, {
    path: "/cs/csm/SCR_CSM_0000",
    component: _6f596416,
    name: "cs-csm-SCR_CSM_0000"
  }, {
    path: "/cs/csm/SCR_CSM_0001",
    component: _6f677b97,
    name: "cs-csm-SCR_CSM_0001"
  }, {
    path: "/cs/csm/SCR_CSM_0002",
    component: _6f759318,
    name: "cs-csm-SCR_CSM_0002"
  }, {
    path: "/cs/csn/SCR_CSN_0001_P",
    component: _74306ee6,
    name: "cs-csn-SCR_CSN_0001_P"
  }, {
    path: "/ds/dsa/SCR_MBC_0050_02_1",
    component: _9e708592,
    name: "ds-dsa-SCR_MBC_0050_02_1"
  }, {
    path: "/ds/dsa/SCR_MBC_0113",
    component: _7ffdc054,
    name: "ds-dsa-SCR_MBC_0113"
  }, {
    path: "/ds/dsa/SCR_MBC_0113_01",
    component: _1f1915fc,
    name: "ds-dsa-SCR_MBC_0113_01"
  }, {
    path: "/ds/dsa/SCR_MBC_0113_01_1",
    component: _0cdcafae,
    name: "ds-dsa-SCR_MBC_0113_01_1"
  }, {
    path: "/ds/dsa/SCR_MBC_0113_02",
    component: _1f272d7d,
    name: "ds-dsa-SCR_MBC_0113_02"
  }, {
    path: "/ds/dsa/SCR_MBC_0113_03",
    component: _1f3544fe,
    name: "ds-dsa-SCR_MBC_0113_03"
  }, {
    path: "/ds/dsa/SCR_MBC_0113_04",
    component: _1f435c7f,
    name: "ds-dsa-SCR_MBC_0113_04"
  }, {
    path: "/ds/dsa/SCR_MBC_0113_05",
    component: _1f517400,
    name: "ds-dsa-SCR_MBC_0113_05"
  }, {
    path: "/ds/dsa/videoTest",
    component: _00b2713a,
    name: "ds-dsa-videoTest"
  }, {
    path: "/ds/dst/SCR_DST_0015",
    component: _8e4de42a,
    name: "ds-dst-SCR_DST_0015"
  }, {
    path: "/ds/keybiz/keyVisualList",
    component: _27737988,
    name: "ds-keybiz-keyVisualList"
  }, {
    path: "/ds/keybiz/pdNotification",
    component: _8a5b4678,
    name: "ds-keybiz-pdNotification"
  }, {
    path: "/ds/rank/boxProduct",
    component: _d1c0d7de,
    name: "ds-rank-boxProduct"
  }, {
    path: "/ds/rank/new",
    component: _5f106b03,
    name: "ds-rank-new"
  }, {
    path: "/ds/rank/pickup",
    component: _6c6bc869,
    name: "ds-rank-pickup"
  }, {
    path: "/ds/rank/popular",
    component: _7ef8123c,
    name: "ds-rank-popular"
  }, {
    path: "/ds/rank/rePurchase",
    component: _59f6f3c1,
    name: "ds-rank-rePurchase"
  }, {
    path: "/ds/rank/review",
    component: _34ebe745,
    name: "ds-rank-review"
  }, {
    path: "/ev/evc/SCR_EVC_0001",
    component: _651ed28c,
    name: "ev-evc-SCR_EVC_0001"
  }, {
    path: "/ev/evc/SCR_EVC_0003",
    component: _653b018e,
    name: "ev-evc-SCR_EVC_0003"
  }, {
    path: "/ev/evc/SCR_EVC_0009",
    component: _658f8e94,
    name: "ev-evc-SCR_EVC_0009"
  }, {
    path: "/ev/evc/SCR_EVC_0011",
    component: _66d3ab2b,
    name: "ev-evc-SCR_EVC_0011"
  }, {
    path: "/ev/evc/SCR_EVC_0013",
    component: _66efda2d,
    name: "ev-evc-SCR_EVC_0013"
  }, {
    path: "/ev/evc/SCR_EVC_0015",
    component: _670c092f,
    name: "ev-evc-SCR_EVC_0015"
  }, {
    path: "/ev/evc/SCR_EVC_0017",
    component: _67283831,
    name: "ev-evc-SCR_EVC_0017"
  }, {
    path: "/ev/evc/SCR_EVC_0019",
    component: _67446733,
    name: "ev-evc-SCR_EVC_0019"
  }, {
    path: "/ev/evd/SCR_EVD_0001",
    component: _1dfa25ca,
    name: "ev-evd-SCR_EVD_0001"
  }, {
    path: "/ev/evd/SCR_EVD_0003",
    component: _1e1654cc,
    name: "ev-evd-SCR_EVD_0003"
  }, {
    path: "/ev/evd/SCR_EVD_0008",
    component: _1e5cca51,
    name: "ev-evd-SCR_EVD_0008"
  }, {
    path: "/ev/evd/SCR_EVD_0009",
    component: _1e6ae1d2,
    name: "ev-evd-SCR_EVD_0009"
  }, {
    path: "/ev/evd/SCR_EVD_0011",
    component: _1faefe69,
    name: "ev-evd-SCR_EVD_0011"
  }, {
    path: "/fb/fba/SCR_FBA_0001",
    component: _1165db0a,
    name: "fb-fba-SCR_FBA_0001"
  }, {
    path: "/fb/fba/SCR_FBA_0003",
    component: _112d7d06,
    name: "fb-fba-SCR_FBA_0003"
  }, {
    path: "/fb/fba/SCR_FBA_0005",
    component: _10f51f02,
    name: "fb-fba-SCR_FBA_0005"
  }, {
    path: "/fb/fba/SCR_FBA_0005_S1",
    component: _32008fae,
    name: "fb-fba-SCR_FBA_0005_S1"
  }, {
    path: "/fb/fba/SCR_FBA_0006",
    component: _10d8f000,
    name: "fb-fba-SCR_FBA_0006"
  }, {
    path: "/fb/fbb/SCR_FBB_0001",
    component: _9faf348e,
    name: "fb-fbb-SCR_FBB_0001"
  }, {
    path: "/fb/fbb/SCR_FBB_0001T1",
    component: _f6dc9554,
    name: "fb-fbb-SCR_FBB_0001T1"
  }, {
    path: "/fb/fbb/SCR_FBB_0001T1B",
    component: _0e9e16dc,
    name: "fb-fbb-SCR_FBB_0001T1B"
  }, {
    path: "/fb/fbb/SCR_FBB_0001T2",
    component: _f6c06652,
    name: "fb-fbb-SCR_FBB_0001T2"
  }, {
    path: "/fb/fbb/SCR_FBB_0002",
    component: _9f93058c,
    name: "fb-fbb-SCR_FBB_0002"
  }, {
    path: "/fb/fbb/SCR_FBB_0003",
    component: _9f76d68a,
    name: "fb-fbb-SCR_FBB_0003"
  }, {
    path: "/fb/fbb/SCR_FBB_0005",
    component: _9f3e7886,
    name: "fb-fbb-SCR_FBB_0005"
  }, {
    path: "/fb/fbb/SCR_FBB_0008",
    component: _9ee9eb80,
    name: "fb-fbb-SCR_FBB_0008"
  }, {
    path: "/fb/fbb/SCR_FBB_0010",
    component: _9c61b252,
    name: "fb-fbb-SCR_FBB_0010"
  }, {
    path: "/fb/fbb/SCR_FBB_0014",
    component: _9bf0f64a,
    name: "fb-fbb-SCR_FBB_0014"
  }, {
    path: "/fb/fbb/SCR_FBB_0015",
    component: _9bd4c748,
    name: "fb-fbb-SCR_FBB_0015"
  }, {
    path: "/mb/mba/SCR_MBA_0080",
    component: _d0ed5a2a,
    name: "mb-mba-SCR_MBA_0080"
  }, {
    path: "/mb/mba/SCR_MBA_0082_01",
    component: _2bd97c7a,
    name: "mb-mba-SCR_MBA_0082_01"
  }, {
    path: "/mb/mba/SCR_MBA_0082_02",
    component: _2bbd4d78,
    name: "mb-mba-SCR_MBA_0082_02"
  }, {
    path: "/mb/mba/SCR_MBA_0082_03",
    component: _2ba11e76,
    name: "mb-mba-SCR_MBA_0082_03"
  }, {
    path: "/mb/mba/SCR_MBA_0082_04",
    component: _2b84ef74,
    name: "mb-mba-SCR_MBA_0082_04"
  }, {
    path: "/mb/mba/SCR_MBA_0082_05",
    component: _2b68c072,
    name: "mb-mba-SCR_MBA_0082_05"
  }, {
    path: "/mb/mba/SCR_MBA_0082_06",
    component: _2b4c9170,
    name: "mb-mba-SCR_MBA_0082_06"
  }, {
    path: "/mb/mba/SCR_MBA_0082_07",
    component: _2b30626e,
    name: "mb-mba-SCR_MBA_0082_07"
  }, {
    path: "/mb/mba/SCR_MBA_0082_09",
    component: _2af8046a,
    name: "mb-mba-SCR_MBA_0082_09"
  }, {
    path: "/mb/mba/SCR_MBA_0082_10",
    component: _288bfa3e,
    name: "mb-mba-SCR_MBA_0082_10"
  }, {
    path: "/mb/mba/SCR_MBA_0084",
    component: _d07c9e22,
    name: "mb-mba-SCR_MBA_0084"
  }, {
    path: "/mb/mba/SCR_MBA_0086_01",
    component: _ecd01582,
    name: "mb-mba-SCR_MBA_0086_01"
  }, {
    path: "/mb/mba/SCR_MBA_0086A",
    component: _64c92820,
    name: "mb-mba-SCR_MBA_0086A"
  }, {
    path: "/mb/mba/SCR_MBA_0086B_01",
    component: _cd0390e2,
    name: "mb-mba-SCR_MBA_0086B_01"
  }, {
    path: "/mb/mba/SCR_MBA_0086B_02",
    component: _cce761e0,
    name: "mb-mba-SCR_MBA_0086B_02"
  }, {
    path: "/mb/mba/SCR_MBA_0086C",
    component: _64e55722,
    name: "mb-mba-SCR_MBA_0086C"
  }, {
    path: "/mb/mba/SCR_MBA_0091",
    component: _cd6779ea,
    name: "mb-mba-SCR_MBA_0091"
  }, {
    path: "/mb/mba/SCR_MBA_0093_01",
    component: _338e44ba,
    name: "mb-mba-SCR_MBA_0093_01"
  }, {
    path: "/mb/mba/SCR_MBA_0093A_01",
    component: _69192ecc,
    name: "mb-mba-SCR_MBA_0093A_01"
  }, {
    path: "/mb/mba/SCR_MBA_0093A_02",
    component: _6927464d,
    name: "mb-mba-SCR_MBA_0093A_02"
  }, {
    path: "/mb/mba/SCR_MBA_0093B",
    component: _d6c21df6,
    name: "mb-mba-SCR_MBA_0093B"
  }, {
    path: "/mb/mba/SCR_MBA_0093C_01",
    component: _38db888a,
    name: "mb-mba-SCR_MBA_0093C_01"
  }, {
    path: "/mb/mba/SCR_MBA_0093C_02",
    component: _38e9a00b,
    name: "mb-mba-SCR_MBA_0093C_02"
  }, {
    path: "/mb/mba/SCR_MBA_0094A",
    component: _d3749bba,
    name: "mb-mba-SCR_MBA_0094A"
  }, {
    path: "/mb/mba/SCR_MBA_0096_01",
    component: _1ddc6440,
    name: "mb-mba-SCR_MBA_0096_01"
  }, {
    path: "/mb/mba/SCR_MBA_0096_02",
    component: _1dea7bc1,
    name: "mb-mba-SCR_MBA_0096_02"
  }, {
    path: "/mb/mba/SCR_MBA_0099_01",
    component: _557feadd,
    name: "mb-mba-SCR_MBA_0099_01"
  }, {
    path: "/mb/mbb/SCR_MBB_0097_01",
    component: _fe4ce5be,
    name: "mb-mbb-SCR_MBB_0097_01"
  }, {
    path: "/mb/mbb/SCR_MBB_0097A",
    component: _04195efc,
    name: "mb-mbb-SCR_MBB_0097A"
  }, {
    path: "/mb/mbb/SCR_MBB_0097B",
    component: _03fd2ffa,
    name: "mb-mbb-SCR_MBB_0097B"
  }, {
    path: "/mb/mbb/SCR_MBB_0098",
    component: _528a3ad0,
    name: "mb-mbb-SCR_MBB_0098"
  }, {
    path: "/mb/mbb/SCR_MBB_0099",
    component: _52985251,
    name: "mb-mbb-SCR_MBB_0099"
  }, {
    path: "/mb/mbb/SCR_MBB_0107_02",
    component: _3ec92eb8,
    name: "mb-mbb-SCR_MBB_0107_02"
  }, {
    path: "/mb/mbb/SCR_MBB_0107A_01",
    component: _20de27b8,
    name: "mb-mbb-SCR_MBB_0107A_01"
  }, {
    path: "/mb/mbb/SCR_MBB_0107B_01",
    component: _ee8156d2,
    name: "mb-mbb-SCR_MBB_0107B_01"
  }, {
    path: "/mb/mbb/SCR_MBB_0109A_01",
    component: _496705ba,
    name: "mb-mbb-SCR_MBB_0109A_01"
  }, {
    path: "/mb/mbb/SCR_MBB_0109A_02",
    component: _49751d3b,
    name: "mb-mbb-SCR_MBB_0109A_02"
  }, {
    path: "/mb/mbb/SCR_MBB_0109A_03",
    component: _498334bc,
    name: "mb-mbb-SCR_MBB_0109A_03"
  }, {
    path: "/mb/mbb/SCR_MBB_0109B_01",
    component: _9d6f9ace,
    name: "mb-mbb-SCR_MBB_0109B_01"
  }, {
    path: "/mb/mbb/SCR_MBB_0109B_02",
    component: _9d536bcc,
    name: "mb-mbb-SCR_MBB_0109B_02"
  }, {
    path: "/mb/mbb/SCR_MBB_0109B_03",
    component: _9d373cca,
    name: "mb-mbb-SCR_MBB_0109B_03"
  }, {
    path: "/mb/mbc/SCR_MBC_0110",
    component: _3234484f,
    name: "mb-mbc-SCR_MBC_0110"
  }, {
    path: "/mb/mbc/SCR_MBC_0110A",
    component: _153fcb82,
    name: "mb-mbc-SCR_MBC_0110A"
  }, {
    path: "/mb/mbc/SCR_MBC_0110A_01",
    component: _6fac140e,
    name: "mb-mbc-SCR_MBC_0110A_01"
  }, {
    path: "/mb/mbc/SCR_MBC_0110A_02",
    component: _6fba2b8f,
    name: "mb-mbc-SCR_MBC_0110A_02"
  }, {
    path: "/mb/mbc/SCR_MBC_0110B_01",
    component: _50e57e26,
    name: "mb-mbc-SCR_MBC_0110B_01"
  }, {
    path: "/mb/mbc/SCR_MBC_0110B_02",
    component: _50c94f24,
    name: "mb-mbc-SCR_MBC_0110B_02"
  }, {
    path: "/mb/mbc/SCR_MBC_0111_01",
    component: _5ed47500,
    name: "mb-mbc-SCR_MBC_0111_01"
  }, {
    path: "/mb/mbc/SCR_MBC_0111A",
    component: _16f4a421,
    name: "mb-mbc-SCR_MBC_0111A"
  }, {
    path: "/mb/mbc/SCR_MBC_0111B",
    component: _1702bba2,
    name: "mb-mbc-SCR_MBC_0111B"
  }, {
    path: "/mb/mbc/SCR_MBC_0111D_01",
    component: _3b9409ac,
    name: "mb-mbc-SCR_MBC_0111D_01"
  }, {
    path: "/mb/mbc/SCR_MBC_0111D_02",
    component: _3ba2212d,
    name: "mb-mbc-SCR_MBC_0111D_02"
  }, {
    path: "/mb/mbc/SCR_MBC_0111D_03",
    component: _3bb038ae,
    name: "mb-mbc-SCR_MBC_0111D_03"
  }, {
    path: "/mb/mbc/SCR_MBC_0112",
    component: _32507751,
    name: "mb-mbc-SCR_MBC_0112"
  }, {
    path: "/mb/mbc/SCR_MBC_0112_2",
    component: _2fcf2744,
    name: "mb-mbc-SCR_MBC_0112_2"
  }, {
    path: "/mb/mbc/SCR_MBC_0113",
    component: _325e8ed2,
    name: "mb-mbc-SCR_MBC_0113"
  }, {
    path: "/mb/mbc/SCR_MBC_0114_01",
    component: _d31008c6,
    name: "mb-mbc-SCR_MBC_0114_01"
  }, {
    path: "/mb/mbc/SCR_MBC_0114_02",
    component: _d2f3d9c4,
    name: "mb-mbc-SCR_MBC_0114_02"
  }, {
    path: "/mb/mbc/SCR_MBC_0115",
    component: _327abdd4,
    name: "mb-mbc-SCR_MBC_0115"
  }, {
    path: "/mb/mbc/SCR_MBC_0115_01",
    component: _034daf08,
    name: "mb-mbc-SCR_MBC_0115_01"
  }, {
    path: "/mb/mbc/SCR_MBC_0115_02",
    component: _03318006,
    name: "mb-mbc-SCR_MBC_0115_02"
  }, {
    path: "/mb/mbc/SCR_MBC_0115_03",
    component: _03155104,
    name: "mb-mbc-SCR_MBC_0115_03"
  }, {
    path: "/mb/mbc/SCR_MBC_0116",
    component: _3288d555,
    name: "mb-mbc-SCR_MBC_0116"
  }, {
    path: "/mb/mbc/SCR_MBC_0117_01",
    component: _63c8fb8c,
    name: "mb-mbc-SCR_MBC_0117_01"
  }, {
    path: "/mb/mbc/SCR_MBC_0117_02",
    component: _63accc8a,
    name: "mb-mbc-SCR_MBC_0117_02"
  }, {
    path: "/mb/mbc/SCR_MBC_0120",
    component: _33e920ee,
    name: "mb-mbc-SCR_MBC_0120"
  }, {
    path: "/mb/mbc/SCR_MBC_0124_01",
    component: _2abc6a9e,
    name: "mb-mbc-SCR_MBC_0124_01"
  }, {
    path: "/mb/mbc/SCR_MBC_0124_02",
    component: _2aca821f,
    name: "mb-mbc-SCR_MBC_0124_02"
  }, {
    path: "/mb/mbc/SCR_MBC_0124_03",
    component: _2ad899a0,
    name: "mb-mbc-SCR_MBC_0124_03"
  }, {
    path: "/ms/msb/SCR_MSB_0001",
    component: _85a48c3a,
    name: "ms-msb-SCR_MSB_0001"
  }, {
    path: "/ms/msb/SCR_MSB_0002",
    component: _85885d38,
    name: "ms-msb-SCR_MSB_0002"
  }, {
    path: "/ms/msb/SCR_MSB_0003",
    component: _856c2e36,
    name: "ms-msb-SCR_MSB_0003"
  }, {
    path: "/ms/msb/SCR_MSB_0004",
    component: _854fff34,
    name: "ms-msb-SCR_MSB_0004"
  }, {
    path: "/ms/msb/SCR_MSB_0009",
    component: _84c3142a,
    name: "ms-msb-SCR_MSB_0009"
  }, {
    path: "/ms/msb/SCR_MSB_TEMP",
    component: _3a276f94,
    name: "ms-msb-SCR_MSB_TEMP"
  }, {
    path: "/ms/msc/SCR_MSC_0001",
    component: _76090d21,
    name: "ms-msc-SCR_MSC_0001"
  }, {
    path: "/ms/msc/SCR_MSC_0002",
    component: _761724a2,
    name: "ms-msc-SCR_MSC_0002"
  }, {
    path: "/ms/msc/SCR_MSC_0003",
    component: _76253c23,
    name: "ms-msc-SCR_MSC_0003"
  }, {
    path: "/ms/mse/SCR_MSE_0001",
    component: _308098c6,
    name: "ms-mse-SCR_MSE_0001"
  }, {
    path: "/ms/mse/SCR_MSE_0002",
    component: _306469c4,
    name: "ms-mse-SCR_MSE_0002"
  }, {
    path: "/ms/msg/SCR_MSG_0015",
    component: _5b6390bc,
    name: "ms-msg-SCR_MSG_0015"
  }, {
    path: "/ms/msg/SCR_MSG_0016",
    component: _5b71a83d,
    name: "ms-msg-SCR_MSG_0016"
  }, {
    path: "/ms/msg/SCR_MSG_0017",
    component: _5b7fbfbe,
    name: "ms-msg-SCR_MSG_0017"
  }, {
    path: "/ms/msg/SCR_MSG_0019",
    component: _5b9beec0,
    name: "ms-msg-SCR_MSG_0019"
  }, {
    path: "/ms/msg/SCR_MSG_0021",
    component: _5ce00b57,
    name: "ms-msg-SCR_MSG_0021"
  }, {
    path: "/or/ora/SCR_ORA_0001",
    component: _e3707cfc,
    name: "or-ora-SCR_ORA_0001"
  }, {
    path: "/or/ora/SCR_ORA_0005",
    component: _e2ffc0f4,
    name: "or-ora-SCR_ORA_0005"
  }, {
    path: "/or/ora/SCR_ORA_0005_S1",
    component: _5f52a172,
    name: "or-ora-SCR_ORA_0005_S1"
  }, {
    path: "/or/ora/SCR_ORA_0006",
    component: _e2e391f2,
    name: "or-ora-SCR_ORA_0006"
  }, {
    path: "/or/ora/SCR_ORA_0007",
    component: _e2c762f0,
    name: "or-ora-SCR_ORA_0007"
  }, {
    path: "/or/ora/SCR_ORA_0009",
    component: _e28f04ec,
    name: "or-ora-SCR_ORA_0009"
  }, {
    path: "/or/ora/SCR_ORA_0009I",
    component: _49b2f9af,
    name: "or-ora-SCR_ORA_0009I"
  }, {
    path: "/or/ora/SCR_ORA_0009P",
    component: _4a159e36,
    name: "or-ora-SCR_ORA_0009P"
  }, {
    path: "/or/ora/SCR_ORA_0010",
    component: _e022fac0,
    name: "or-ora-SCR_ORA_0010"
  }, {
    path: "/or/ora/SCR_ORA_0011",
    component: _e006cbbe,
    name: "or-ora-SCR_ORA_0011"
  }, {
    path: "/or/ora/SCR_ORA_0013",
    component: _dfce6dba,
    name: "or-ora-SCR_ORA_0013"
  }, {
    path: "/or/ora/SCR_ORA_0014",
    component: _dfb23eb8,
    name: "or-ora-SCR_ORA_0014"
  }, {
    path: "/or/ora/SCR_ORA_0015",
    component: _df960fb6,
    name: "or-ora-SCR_ORA_0015"
  }, {
    path: "/or/orb/cancelCompletePopUp",
    component: _21419187,
    name: "or-orb-cancelCompletePopUp"
  }, {
    path: "/or/orb/ExchangeList",
    component: _238da3a3,
    name: "or-orb-ExchangeList"
  }, {
    path: "/or/orb/NoCancelList",
    component: _4b27311b,
    name: "or-orb-NoCancelList"
  }, {
    path: "/or/orb/NoExchangeList",
    component: _7bfe1df8,
    name: "or-orb-NoExchangeList"
  }, {
    path: "/or/orb/OrBtnCmp",
    component: _aa11eb62,
    name: "or-orb-OrBtnCmp"
  }, {
    path: "/or/orb/OrClAdditPyUnit",
    component: _17768b8a,
    name: "or-orb-OrClAdditPyUnit"
  }, {
    path: "/or/orb/OrClDlvInfoUnit",
    component: _d3e37d7c,
    name: "or-orb-OrClDlvInfoUnit"
  }, {
    path: "/or/orb/OrClPdListUnit",
    component: _3964ab64,
    name: "or-orb-OrClPdListUnit"
  }, {
    path: "/or/orb/OrClRetnInfoUnit",
    component: _cd94ab26,
    name: "or-orb-OrClRetnInfoUnit"
  }, {
    path: "/or/orb/OrClRetnPyInfoUnit",
    component: _1c881b54,
    name: "or-orb-OrClRetnPyInfoUnit"
  }, {
    path: "/or/orb/SCR_ORB_0001",
    component: _472314c0,
    name: "or-orb-SCR_ORB_0001"
  }, {
    path: "/or/orb/SCR_ORB_0002",
    component: _47312c41,
    name: "or-orb-SCR_ORB_0002"
  }, {
    path: "/or/orb/SCR_ORB_0003",
    component: _473f43c2,
    name: "or-orb-SCR_ORB_0003"
  }, {
    path: "/or/orb/SCR_ORB_0004",
    component: _474d5b43,
    name: "or-orb-SCR_ORB_0004"
  }, {
    path: "/or/orb/SCR_ORB_0005",
    component: _475b72c4,
    name: "or-orb-SCR_ORB_0005"
  }, {
    path: "/or/orb/SCR_ORB_0005_S1",
    component: _691aa96e,
    name: "or-orb-SCR_ORB_0005_S1"
  }, {
    path: "/or/orb/SCR_ORB_0006",
    component: _47698a45,
    name: "or-orb-SCR_ORB_0006"
  }, {
    path: "/or/orb/SCR_ORB_0007",
    component: _4777a1c6,
    name: "or-orb-SCR_ORB_0007"
  }, {
    path: "/or/orb/SCR_ORB_0010",
    component: _48c9d5de,
    name: "or-orb-SCR_ORB_0010"
  }, {
    path: "/or/orb/SCR_ORB_0013",
    component: _48f41c61,
    name: "or-orb-SCR_ORB_0013"
  }, {
    path: "/or/orb/SCR_ORB_0014",
    component: _490233e2,
    name: "or-orb-SCR_ORB_0014"
  }, {
    path: "/or/orb/SCR_ORB_0015",
    component: _49104b63,
    name: "or-orb-SCR_ORB_0015"
  }, {
    path: "/or/orb/SCR_ORB_0016",
    component: _491e62e4,
    name: "or-orb-SCR_ORB_0016"
  }, {
    path: "/or/orb/SCR_ORB_0017",
    component: _492c7a65,
    name: "or-orb-SCR_ORB_0017"
  }, {
    path: "/or/orb/SCR_ORB_0018",
    component: _493a91e6,
    name: "or-orb-SCR_ORB_0018"
  }, {
    path: "/or/orb/SCR_ORB_0019",
    component: _4948a967,
    name: "or-orb-SCR_ORB_0019"
  }, {
    path: "/or/orb/SCR_ORB_0021",
    component: _4a8cc5fe,
    name: "or-orb-SCR_ORB_0021"
  }, {
    path: "/or/orb/SCR_ORB_0023",
    component: _4aa8f500,
    name: "or-orb-SCR_ORB_0023"
  }, {
    path: "/or/orb/SCR_ORB_0024",
    component: _4ab70c81,
    name: "or-orb-SCR_ORB_0024"
  }, {
    path: "/or/orb/SCR_ORB_0025",
    component: _4ac52402,
    name: "or-orb-SCR_ORB_0025"
  }, {
    path: "/or/orb/SCR_ORB_0026",
    component: _4ad33b83,
    name: "or-orb-SCR_ORB_0026"
  }, {
    path: "/or/orb/SCR_ORB_0033",
    component: _4c5dcd9f,
    name: "or-orb-SCR_ORB_0033"
  }, {
    path: "/or/orb/SCR_ORB_0036",
    component: _4c881422,
    name: "or-orb-SCR_ORB_0036"
  }, {
    path: "/or/orb/SCR_ORB_0037",
    component: _4c962ba3,
    name: "or-orb-SCR_ORB_0037"
  }, {
    path: "/or/orb/SCR_ORB_0050",
    component: _4f9d385a,
    name: "or-orb-SCR_ORB_0050"
  }, {
    path: "/or/orb/UX_07_055",
    component: _00067afc,
    name: "or-orb-UX_07_055"
  }, {
    path: "/or/orb/UX_07_125",
    component: _2fc473e6,
    name: "or-orb-UX_07_125"
  }, {
    path: "/or/orc/SCR_ORC_0001",
    component: _00033004,
    name: "or-orc-SCR_ORC_0001"
  }, {
    path: "/or/orc/SCR_ORC_0001_T1",
    component: _28becc6e,
    name: "or-orc-SCR_ORC_0001_T1"
  }, {
    path: "/or/orc/SCR_ORC_0001_T2",
    component: _28cce3ef,
    name: "or-orc-SCR_ORC_0001_T2"
  }, {
    path: "/or/orc/SCR_ORC_0001_T3",
    component: _28dafb70,
    name: "or-orc-SCR_ORC_0001_T3"
  }, {
    path: "/or/orc/SCR_ORC_0001_T4",
    component: _28e912f1,
    name: "or-orc-SCR_ORC_0001_T4"
  }, {
    path: "/or/orc/SCR_ORC_0001_T4_P1",
    component: _b31213c2,
    name: "or-orc-SCR_ORC_0001_T4_P1"
  }, {
    path: "/or/orc/SCR_ORC_0001_T4_P2",
    component: _b2f5e4c0,
    name: "or-orc-SCR_ORC_0001_T4_P2"
  }, {
    path: "/or/orc/SCR_ORC_0001_T5",
    component: _28f72a72,
    name: "or-orc-SCR_ORC_0001_T5"
  }, {
    path: "/or/orc/SCR_ORC_0003",
    component: _001a9700,
    name: "or-orc-SCR_ORC_0003"
  }, {
    path: "/or/orc/SCR_ORC_0007",
    component: _0052f504,
    name: "or-orc-SCR_ORC_0007"
  }, {
    path: "/pd/pdm/SCR_PDM_0002",
    component: _9a00fdc8,
    name: "pd-pdm-SCR_PDM_0002"
  }, {
    path: "/pd/pdr/SCR_PDR_0001",
    component: _4f3a09d1,
    name: "pd-pdr-SCR_PDR_0001"
  }, {
    path: "/pd/pds/SCR_PDS_0000",
    component: _0807458e,
    name: "pd-pds-SCR_PDS_0000"
  }, {
    path: "/pd/pds/SCR_PDS_0005",
    component: _084dbb13,
    name: "pd-pds-SCR_PDS_0005"
  }, {
    path: "/pd/pds/SCR_PDS_0006",
    component: _085bd294,
    name: "pd-pds-SCR_PDS_0006"
  }, {
    path: "/pd/pdt/SCR_PDT_0001",
    component: _7e1e9f66,
    name: "pd-pdt-SCR_PDT_0001"
  }, {
    path: "/pd/pdt/SCR_PDT_0002",
    component: _7e027064,
    name: "pd-pdt-SCR_PDT_0002"
  }, {
    path: "/pd/pdt/SCR_PDT_0003",
    component: _7de64162,
    name: "pd-pdt-SCR_PDT_0003"
  }, {
    path: "/pd/pdt/SCR_PDT_0004",
    component: _7dca1260,
    name: "pd-pdt-SCR_PDT_0004"
  }, {
    path: "/py/pya/SCR_PYA_0002",
    component: _276c97e9,
    name: "py-pya-SCR_PYA_0002"
  }, {
    path: "/py/pya/SCR_PYA_0003",
    component: _277aaf6a,
    name: "py-pya-SCR_PYA_0003"
  }, {
    path: "/py/pya/SCR_PYA_0004",
    component: _2788c6eb,
    name: "py-pya-SCR_PYA_0004"
  }, {
    path: "/py/pya/SCR_PYA_0005",
    component: _2796de6c,
    name: "py-pya-SCR_PYA_0005"
  }, {
    path: "/py/pya/SCR_PYA_0007",
    component: _27b30d6e,
    name: "py-pya-SCR_PYA_0007"
  }, {
    path: "/ug/ugc/SCR_UGC_030",
    component: _3254929e,
    name: "ug-ugc-SCR_UGC_030"
  }, {
    path: "/ug/ugd/SCR_UGD_0004",
    component: _0e3d994e,
    name: "ug-ugd-SCR_UGD_0004"
  }, {
    path: "/ug/ugd/SCR_UGD_0007",
    component: _0e67dfd1,
    name: "ug-ugd-SCR_UGD_0007"
  }, {
    path: "/ug/ugd/SCR_UGD_0008",
    component: _0e75f752,
    name: "ug-ugd-SCR_UGD_0008"
  }, {
    path: "/ug/ugd/SCR_UGD_0014",
    component: _0ff271ed,
    name: "ug-ugd-SCR_UGD_0014"
  }, {
    path: "/ug/ugd/SCR_UGD_0019",
    component: _1038e772,
    name: "ug-ugd-SCR_UGD_0019"
  }, {
    path: "/ug/ugd/SCR_UGD_0022",
    component: _118b1b8a,
    name: "ug-ugd-SCR_UGD_0022"
  }, {
    path: "/ug/ugd/SCR_UGD_0023",
    component: _1199330b,
    name: "ug-ugd-SCR_UGD_0023"
  }, {
    path: "/ug/ugd/SCR_UGD_0028",
    component: _11dfa890,
    name: "ug-ugd-SCR_UGD_0028"
  }, {
    path: "/ug/ugd/SCR_UGD_00282",
    component: _2a2d12d2,
    name: "ug-ugd-SCR_UGD_00282"
  }, {
    path: "/ug/ugd/SCR_UGD_0029",
    component: _11edc011,
    name: "ug-ugd-SCR_UGD_0029"
  }, {
    path: "/ug/ugd/SCR_UGD_0030",
    component: _1323c527,
    name: "ug-ugd-SCR_UGD_0030"
  }, {
    path: "/ug/ugd/SCR_UGD_0031",
    component: _1331dca8,
    name: "ug-ugd-SCR_UGD_0031"
  }, {
    path: "/ug/ugd/SCR_UGD_0032",
    component: _133ff429,
    name: "ug-ugd-SCR_UGD_0032"
  }, {
    path: "/ug/ugd/SCR_UGD_0033",
    component: _134e0baa,
    name: "ug-ugd-SCR_UGD_0033"
  }, {
    path: "/ug/ugd/SCR_UGD_0033_P1",
    component: _62a316c6,
    name: "ug-ugd-SCR_UGD_0033_P1"
  }, {
    path: "/ug/ugd/SCR_UGD_00up",
    component: _f16d0336,
    name: "ug-ugd-SCR_UGD_00up"
  }, {
    path: "/ug/ugl/SCR_UGL_0001",
    component: _5624268a,
    name: "ug-ugl-SCR_UGL_0001"
  }, {
    path: "/ug/ugm/SCR_UGM_0001",
    component: _e46d800e,
    name: "ug-ugm-SCR_UGM_0001"
  }, {
    path: "/ug/ugm/SCR_UGM_0002",
    component: _e451510c,
    name: "ug-ugm-SCR_UGM_0002"
  }, {
    path: "/ug/ugp/SCR_UGP_0001",
    component: _8f498c9a,
    name: "ug-ugp-SCR_UGP_0001"
  }, {
    path: "/ug/ugp/SCR_UGP_0002",
    component: _8f2d5d98,
    name: "ug-ugp-SCR_UGP_0002"
  }, {
    path: "/ug/ugp/SCR_UGP_0003",
    component: _8f112e96,
    name: "ug-ugp-SCR_UGP_0003"
  }, {
    path: "/ug/ugp/SCR_UGP_0003_P1",
    component: _6b2599db,
    name: "ug-ugp-SCR_UGP_0003_P1"
  }, {
    path: "/ug/ugp/SCR_UGP_00030",
    component: _5671284b,
    name: "ug-ugp-SCR_UGP_00030"
  }, {
    path: "/ug/ugp/SCR_UGP_0004",
    component: _8ef4ff94,
    name: "ug-ugp-SCR_UGP_0004"
  }, {
    path: "/ug/ugp/SCR_UGP_0005",
    component: _8ed8d092,
    name: "ug-ugp-SCR_UGP_0005"
  }, {
    path: "/ug/ugp/SCR_UGP_0007",
    component: _8ea0728e,
    name: "ug-ugp-SCR_UGP_0007"
  }, {
    path: "/ug/ugp/SCR_UGP_0007_P1",
    component: _0aaa4d57,
    name: "ug-ugp-SCR_UGP_0007_P1"
  }, {
    path: "/ug/ugp/SCR_UGP_0009",
    component: _8e68148a,
    name: "ug-ugp-SCR_UGP_0009"
  }, {
    path: "/ug/ugp/SCR_UGP_0010",
    component: _8bfc0a5e,
    name: "ug-ugp-SCR_UGP_0010"
  }, {
    path: "/ug/ugp/SCR_UGP_0010_P1",
    component: _7072fb82,
    name: "ug-ugp-SCR_UGP_0010_P1"
  }, {
    path: "/ug/ugp/SCR_UGP_0012",
    component: _8bc3ac5a,
    name: "ug-ugp-SCR_UGP_0012"
  }, {
    path: "/ug/ugp/SCR_UGP_0013",
    component: _8ba77d58,
    name: "ug-ugp-SCR_UGP_0013"
  }, {
    path: "/ug/ugp/SCR_UGP_0014",
    component: _8b8b4e56,
    name: "ug-ugp-SCR_UGP_0014"
  }, {
    path: "/ug/ugp/SCR_UGP_0017",
    component: _8b36c150,
    name: "ug-ugp-SCR_UGP_0017"
  }, {
    path: "/ug/ugp/SCR_UGP_0018",
    component: _8b1a924e,
    name: "ug-ugp-SCR_UGP_0018"
  }, {
    path: "/ug/ugp/SCR_UGP_0019",
    component: _8afe634c,
    name: "ug-ugp-SCR_UGP_0019"
  }, {
    path: "/ug/ugp/SCR_UGP_0019_P1",
    component: _6eb11616,
    name: "ug-ugp-SCR_UGP_0019_P1"
  }, {
    path: "/ug/ugp/SCR_UGP_0020",
    component: _88925920,
    name: "ug-ugp-SCR_UGP_0020"
  }, {
    path: "/ds/bulkOrder/dsList/:id?",
    component: _4cd852d1,
    name: "ds-bulkOrder-dsList-id"
  }, {
    path: "/ds/pickupOrder/dsList/:id?",
    component: _5a65bfbb,
    name: "ds-pickupOrder-dsList-id"
  }, {
    path: "/ds/quickOrder/dsList/:id?",
    component: _6cf86890,
    name: "ds-quickOrder-dsList-id"
  }, {
    path: "/ds/bulkOrder/:id?",
    component: _481e94b1,
    name: "ds-bulkOrder-id"
  }, {
    path: "/ds/diy/:id?",
    component: _48717569,
    name: "ds-diy-id"
  }, {
    path: "/ds/diy2/:id?",
    component: _02b4460f,
    name: "ds-diy2-id"
  }, {
    path: "/ds/dst/:id?",
    component: _240c94cc,
    name: "ds-dst-id"
  }, {
    path: "/ds/dsTest/:id?",
    component: _382fd19c,
    name: "ds-dsTest-id"
  }, {
    path: "/ds/exbt/:id?",
    component: _0ad7d936,
    name: "ds-exbt-id"
  }, {
    path: "/ds/fb/:id?",
    component: _bf774ba6,
    name: "ds-fb-id"
  }, {
    path: "/ds/godbin/:id?",
    component: _f12edb08,
    name: "ds-godbin-id"
  }, {
    path: "/ds/goods/:id?",
    component: _1547c9ab,
    name: "ds-goods-id"
  }, {
    path: "/ds/goodssub/:id?",
    component: _7172c41b,
    name: "ds-goodssub-id"
  }, {
    path: "/ds/new/:id?",
    component: _1fb1ce75,
    name: "ds-new-id"
  }, {
    path: "/ds/pickupOrder/:id?",
    component: _ecf109f2,
    name: "ds-pickupOrder-id"
  }, {
    path: "/ds/prodGift/:id?",
    component: _66309518,
    name: "ds-prodGift-id"
  }, {
    path: "/ds/quickOrder/:id?",
    component: _bb9c305c,
    name: "ds-quickOrder-id"
  }, {
    path: "/ds/rank/:id?",
    component: _4b5a961d,
    name: "ds-rank-id"
  }, {
    path: "/ds/recmd/:id?",
    component: _185a9908,
    name: "ds-recmd-id"
  }, {
    path: "/ds/recmd2/:id?",
    component: _790a6b48,
    name: "ds-recmd2-id"
  }, {
    path: "/ds/specialist/:id?",
    component: _52126ba2,
    name: "ds-specialist-id"
  }, {
    path: "/ds/specialProds/:id?",
    component: _52695098,
    name: "ds-specialProds-id"
  }, {
    path: "/ds/dsBrand/:id?/:brandId?",
    component: _358cc2b5,
    name: "ds-dsBrand-id-brandId"
  }, {
    path: "/ds/spexhbt/:id?/:exbtId?",
    component: _2396abe2,
    name: "ds-spexhbt-id-exbtId"
  }, {
    path: "/ds/exhCtgr/:cnrId?/:lgCtgrNo?/:mdCtgrNo?/:smCtgrNo?",
    component: _6c86645a,
    name: "ds-exhCtgr-cnrId-lgCtgrNo-mdCtgrNo-smCtgrNo"
  }, {
    path: "/",
    redirect: (_to) => {
          return '/ds';
        },
    name: "home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
